import { useEffect, useState } from "react";
import { FiBriefcase } from "react-icons/fi";
import { BUDGET_ORGANIZATIONS } from "../constants/organizations";

const STORAGE_KEY = "budgetOrganizationView";

export function setStoredBudgetOrganizationView(value) {
  try {
    const v = String(value || "").trim().toUpperCase();
    if (BUDGET_ORGANIZATIONS.includes(v)) {
      localStorage.setItem(STORAGE_KEY, v);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function getStoredBudgetOrganizationView() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return "";
    const v = String(raw).trim().toUpperCase();
    return BUDGET_ORGANIZATIONS.includes(v) ? v : "";
  } catch {
    return "";
  }
}

const ORG_OPTIONS = [
  { value: "", label: "All organisations" },
  ...BUDGET_ORGANIZATIONS.map((o) => ({ value: o, label: o })),
];

export default function BudgetOrganizationSwitcher({ onChange }) {
  const [value, setValue] = useState(() => getStoredBudgetOrganizationView());

  useEffect(() => {
    setValue(getStoredBudgetOrganizationView());
  }, []);

  const handleSelect = (next) => {
    setValue(next);
    setStoredBudgetOrganizationView(next);
    onChange?.(next);
    window.dispatchEvent(new CustomEvent("budgetOrganizationViewChanged", { detail: next }));
  };

  const displayOrg = value || "All organisations";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        marginBottom: 12,
        padding: "12px 16px",
        borderRadius: 14,
        background: "linear-gradient(135deg, #EAF6FD 0%, #f8fafc 100%)",
        border: "1px solid #a9ddf5",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#EAF6FD",
            color: "#2C63AE",
            flexShrink: 0,
          }}
        >
          <FiBriefcase size={18} />
        </div>
        <div style={{ minWidth: 0 }}>
          <div
            style={{
              fontSize: "0.72rem",
              fontWeight: 700,
              color: "#2C63AE",
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            Organisation view
          </div>
          <div style={{ fontSize: "0.88rem", fontWeight: 700, color: "#0f172a" }}>{displayOrg}</div>
        </div>
      </div>

      <div
        role="tablist"
        aria-label="Organisation view"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 8,
          padding: 4,
          borderRadius: 12,
          background: "#e0e7ff",
          border: "1px solid #c7d2fe",
        }}
      >
        {ORG_OPTIONS.map((opt) => {
          const active = value === opt.value;
          return (
            <button
              key={opt.value || "all"}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => handleSelect(opt.value)}
              style={{
                border: "none",
                borderRadius: 9,
                padding: "8px 14px",
                fontSize: "0.82rem",
                fontWeight: 700,
                cursor: "pointer",
                transition: "all 0.15s ease",
                background: active ? "#2C63AE" : "transparent",
                color: active ? "#ffffff" : "#475569",
                boxShadow: active ? "0 4px 12px rgba(44, 99, 174, 0.28)" : "none",
                whiteSpace: "nowrap",
              }}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
